import React from "react";
import pub1 from "../image/pub1.jpeg";
import pub2 from "../image/pub2.jpeg";
import Navigation from "./Navbar";
import Footer from "./Footer";
import { FaGlobe, FaHeartbeat, FaUsers, FaIndustry } from "react-icons/fa";

const Publication = () => {
  return (
    <div>
      {/* Navbar */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
        <Navigation />
      </div>

      <div className="lg:pt-[210px] pt-[170px] pb-20">
        <div className="max-w-6xl mx-auto px-6">
          
          {/* Header */}
          <div className="flex items-center justify-center mb-12">
            <div className="h-[2px] w-32 bg-gradient-to-r from-transparent to-blue-900"></div>
            <h2 className="text-4xl font-bold px-8 text-orange-600">
              Publications
            </h2>
            <div className="h-[2px] w-32 bg-gradient-to-l from-transparent to-blue-900"></div>
          </div>

          {/* Publications Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            
            {/* Publication 1 */}
            <a
              href="https://www.gshealthjournal.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden"
            >
              <div className=" h-auto  relative">
                <img
                  src={pub1}
                  alt="Global South Healthcare Journal"
                  className="w-full  h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition"></div>
              </div>

              <div className="bg-white p-6">
                <h3 className="text-xl font-bold text-blue-900 mb-2">
                  Global South Healthcare Journal
                </h3>
                <p className="text-gray-600 mb-4">
                  A premier health journal featuring cutting-edge medical and public health research.
                </p>
                <span className="text-orange-600 font-semibold">
                  Visit Journal →
                </span>
              </div>
            </a>

            {/* Publication 2 */}
            <div className="group rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden">
              <div className=" h-auto relative">
                <img
                  src={pub2}
                  alt="Corporate Jugalbandi"
                  className="w-full  h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition"></div>
              </div>

              <div className="bg-white p-6">
                <h3 className="text-xl font-bold text-blue-900 mb-2">
                  Corporate Jugalbandi @ Boardroom
                </h3>
                <p className="text-gray-600">
                  Corporate Symphony for strategic leadership and governance insights.
                </p>
              </div>
            </div>
          </div>

          {/* Additional Research – Redesigned */}
          <div className="mt-20">
            <h3 className="text-3xl font-bold text-center text-blue-900 mb-12">
              Additional Research Initiatives
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              
              {/* Card 1 */}
              <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition p-6 flex gap-4">
                <FaGlobe className="text-4xl text-orange-600" />
                <div>
                  <h4 className="text-lg font-semibold text-gray-800">
                    Digital Global Health Architecture (d-GHA)
                  </h4>
                  {/*<p className="text-gray-600 text-sm mt-1">
                    Strategic framework analysis for global digital health systems.
                  </p>*/}
                </div>
              </div>

              {/* Card 2 */}
              <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition p-6 flex gap-4">
                <FaHeartbeat className="text-4xl text-orange-600" />
                <div>
                  <h4 className="text-lg font-semibold text-gray-800">
                    Revisiting Medical Inflation
                  </h4>
                  {/*<p className="text-gray-600 text-sm mt-1">
                    Deep research on rising healthcare costs and economic impact.
                  </p>*/}
                </div>
              </div>

              {/* Card 3 */}
              <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition p-6 flex gap-4">
                <FaUsers className="text-4xl text-orange-600" />
                <div>
                  <h4 className="text-lg font-semibold text-gray-800">
                    White Paper on Tribal Health
                  </h4>
                 {/* <p className="text-gray-600 text-sm mt-1">
                    Insights into indigenous healthcare systems and accessibility.
                  </p>*/}
                </div>
              </div>

              {/* Card 4 */}
              <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition p-6 flex gap-4">
                <FaIndustry className="text-4xl text-orange-600" />
                <div>
                  <h4 className="text-lg font-semibold text-gray-800">
                    Indian Pharma Vision 2047
                  </h4>
                  {/*<p className="text-gray-600 text-sm mt-1">
                    Strategic roadmap aligned with the Viksit Bharat Mission.
                  </p>*/}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Publication;
